import { Directive, TemplateRef } from '@angular/core';

/**
 * Only used to inject templates and know what it is intended to replace
 */
@Directive({ selector: '[ui-dialog-template]' })
export class UIDialogTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
